import React, { Component } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from "recharts";
import { calculaPorcentaje } from "../utils/helpers.js";

export default class GraficoTartas extends Component {
	constructor(props) {
		super();
		if (props.agrupaciones) {
			// let clasPor = props.agrupaciones[props.ide]["clas_tot"];
			let clas = calculaPorcentaje(
				props.agrupaciones[props.ide]["clas_tot"],
				300
			);
			let cuar = calculaPorcentaje(
				props.agrupaciones[props.ide]["cuar_tot"],
				300
			);
			let semis = calculaPorcentaje(
				props.agrupaciones[props.ide]["semis_tot"],
				600
			);
			this.state = {
				activeIndex: 0,
				animation: true,
				data01: [
					{ name: "Group A", value: clas },
					{ name: "Resto", value: 100 - clas }
				],
				data02: [
					{ name: "Group A", value: cuar },
					{ name: "Resto", value: 100 - cuar }
				],
				data03: [
					{ name: "Group A", value: semis },
					{ name: "Resto", value: 100 - semis }
				]
			};
		}

		// BINDINGS
	}

	render() {
		const { data01 } = this.state;
		const secColor = "#F0F0F0";
		return (
			<div
				className="pie-charts"
				style={{ fontFamily: "Roboto", height: "auto" }}
			>
				<div
					className="pie-chart-wrapper"
					style={{
						width: "33.3333%",
						display: "inline-block",
						height: "100px"
					}}
				>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center"
						}}
					>
						Clasificatoria
					</h6>
					<ResponsiveContainer style={{ height: "auto" }}>
						<PieChart style={{ strokeWidth: "0px" }}>
							<Pie
								key={Math.random()}
								data={this.state.data01}
								nameKey="name"
								dataKey="value"
								innerRadius="85%"
								outerRadius="95%"
								isAnimationActive={true}
								animationBegin={600}
								startAngle={-180}
							>
								<Cell fill={this.props.mainColor} />
								<Cell fill={secColor} />

								<Label
									width={50}
									position="center"
									style={{ fontWeight: "500", fontSize: "22px" }}
								>
									{this.state.data01[0].value !== 0
										? `${this.state.data01[0].value}%`
										: "%"}
								</Label>
							</Pie>
						</PieChart>
					</ResponsiveContainer>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center",
							fontWeight: 700
						}}
					>
						{this.props.agrupaciones[this.props.ide]
							? this.props.agrupaciones[this.props.ide]["clas_tot"]
							: 0}{" "}
						ptos.
					</h6>
				</div>
				<div
					className="pie-chart-wrapper"
					style={{
						width: "33.3333%",
						display: "inline-block",
						height: "100px"
					}}
				>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center"
						}}
					>
						Cuartos
					</h6>
					<ResponsiveContainer style={{ height: "auto" }}>
						<PieChart style={{ strokeWidth: "0px" }}>
							<Pie
								key={Math.random()}
								data={this.state.data02}
								nameKey="name"
								dataKey="value"
								innerRadius="85%"
								outerRadius="95%"
								isAnimationActive={true}
								animationBegin={600}
								startAngle={-180}
							>
								<Cell fill={this.props.mainColor} />
								<Cell fill={secColor} />
								<Label
									width={50}
									position="center"
									style={{ fontWeight: "500", fontSize: "22px" }}
								>
									{this.state.data02[0].value !== 0
										? `${this.state.data02[0].value}%`
										: "%"}
								</Label>
							</Pie>
						</PieChart>
					</ResponsiveContainer>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center",
							fontWeight: 700
						}}
					>
						{this.props.agrupaciones[this.props.ide]
							? this.props.agrupaciones[this.props.ide]["cuar_tot"]
							: 0}{" "}
						ptos.
					</h6>
				</div>
				<div
					className="pie-chart-wrapper"
					style={{
						width: "33.3333%",
						display: "inline-block",
						height: "100px"
					}}
				>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center"
						}}
					>
						Semifinal
					</h6>
					<ResponsiveContainer style={{ height: "auto" }}>
						<PieChart style={{ strokeWidth: "0px" }}>
							<Pie
								key={Math.random()}
								data={this.state.data03}
								nameKey="name"
								dataKey="value"
								innerRadius="85%"
								outerRadius="95%"
								isAnimationActive={true}
								animationBegin={600}
								startAngle={-180}
							>
								<Cell fill={this.props.mainColor} />
								<Cell fill={secColor} />
								<Label
									width={50}
									position="center"
									style={{ fontWeight: "500", fontSize: "22px" }}
								>
									{this.state.data03[0].value !== 0
										? `${this.state.data03[0].value}%`
										: "%"}
								</Label>
							</Pie>
						</PieChart>
					</ResponsiveContainer>
					<h6
						style={{
							marginBottom: 0,
							textAlign: "center",
							fontWeight: 700
						}}
					>
						{this.props.agrupaciones[this.props.ide]
							? this.props.agrupaciones[this.props.ide]["semis_tot"]
							: 0}{" "}
						ptos.
					</h6>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/GraficoTartas.js